//AadhaarDetailsAPI.js

import axios from "axios";
import API_BASE_URL from "../BaseURL/baseURL";
import { toast } from "react-toastify";

export function checkAadhaar(Aadhaar) {
  return new Promise(async (resolve, reject) => {
    try {
      //debugger;
      const response = await axios.post(
        `${API_BASE_URL}/Aadhaar/AadhaarOtp?Aadhaar=${encodeURIComponent(
          Aadhaar
        )}`
      );
      if (response.status === 200) {
        toast.success("Aadhaar OTP send successfully!");
        console.log("Aadhaar otp:", response.data);
        resolve(response.data);
      } else {
        reject({ message: "Aadhaar authentication failed" });
        toast.error("Failed to send aadhaar otp");
      }
    } catch (error) {
      console.log(error);
      reject(error);
    }
  });
}

export function fetchAadhaarDetails(Aadhaar) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/Aadhaar/FetchAadhaarDetails?Aadhaar=${encodeURIComponent(
          Aadhaar
        )}`
      );
      if (response.status === 200) {
        resolve(response.data);
      } else {
        reject({ message: "Failed to fetch Aadhaar details" });
      }
    } catch (error) {
      console.log(error);
      reject(error);
    }
  });
}
